import PropTypes from "prop-types";
import "./ConfirmModal.scss";

const ConfirmModal = ({ isOpen, title, message, onYes, onClose }) => {
  if (!isOpen) return null;

  const handleNo = () => {
    if (onClose) onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        {title && <h2 className="modal-title">{title}</h2>}
        <p className="modal-message">{message}</p>
        <div className="modal-actions">
          <button className="btn yes" onClick={onYes}>
            Yes
          </button>
          <button className="btn no" onClick={handleNo}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.node,
  onYes: PropTypes.func,
  onClose: PropTypes.func,
};

export default ConfirmModal;
